import { Link } from 'react-router-dom';
import { FileText, ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { Blueprint } from '@/types';
import { useState } from 'react';

interface SessionBlueprintsPanelProps {
  blueprints: Blueprint[];
  isLoading?: boolean;
}

export default function SessionBlueprintsPanel({
  blueprints,
  isLoading = false
}: SessionBlueprintsPanelProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (blueprints.length === 0) {
    return null;
  }

  return (
    <div className="relative">
      {/* Compact Button */}
      <Button
        size="sm"
        variant="ghost"
        onClick={() => setIsExpanded(!isExpanded)}
        className="h-8 gap-2"
      >
        <FileText className="h-4 w-4" />
        <span className="text-sm">会话蓝图</span>
        <span className="rounded-full bg-primary/10 px-2 py-0.5 text-xs text-primary">
          {blueprints.length}
        </span>
        {isExpanded ? (
          <ChevronUp className="h-3 w-3 ml-1" />
        ) : (
          <ChevronDown className="h-3 w-3 ml-1" />
        )}
      </Button>

      {/* Dropdown Panel */}
      {isExpanded && (
        <div className="absolute right-0 top-full mt-2 w-80 z-50 animate-in slide-in-from-top-2">
          <div className="rounded-lg border bg-card shadow-lg">
            <div className="max-h-[400px] overflow-y-auto p-2">
              {isLoading ? (
                <div className="p-4 text-center text-sm text-muted-foreground">
                  加载中...
                </div>
              ) : (
                <div className="space-y-2">
                  {blueprints.map((blueprint) => (
                    <Link
                      key={blueprint.id}
                      to={`/blueprints/${blueprint.id}`}
                      onClick={() => setIsExpanded(false)}
                      className="block rounded-md border bg-background p-3 transition-colors hover:bg-accent"
                    >
                      <div className="font-medium text-sm line-clamp-1">
                        {blueprint.title}
                      </div>
                      <div className="mt-1 text-xs text-muted-foreground line-clamp-2">
                        {blueprint.description}
                      </div>
                      {blueprint.priority && (
                        <div className="mt-2">
                          <span className="inline-block rounded bg-primary/10 px-2 py-0.5 text-xs text-primary capitalize">
                            {blueprint.priority}
                          </span>
                        </div>
                      )}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
